/** EN uses Swedish values until translated. */
export const reportsTranslationsEn = {
    title: 'Reports',
    contactPrefix: 'You can reach us at',
    contactSuffix: '.',
}
